export default __webpack_public_path__ + "static/media/pet-covers.565afc83.jpg";